import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
import Caret from './Caret';
import Button from '../button/Button';
const SplitCaretButton = forwardRef((props, ref) => {
    const { disabled = false, bsStyle, bsSize, onClick, className } = props, remainingProps = __rest(props, ["disabled", "bsStyle", "bsSize", "onClick", "className"]);
    const splitCaretButtonClasses = classNames('dropdown-toggle', className);
    return (_jsx(Button, Object.assign({}, remainingProps, { type: 'button', ref: ref, disabled: disabled, bsStyle: bsStyle, bsSize: bsSize, onClick: onClick, className: splitCaretButtonClasses }, { children: _jsx(Caret, {}) })));
});
export default SplitCaretButton;
